import React from 'react';
import { useStyle } from './PrequalStyle.js';
import { Typography } from '@material-ui/core';

export default function Loading() {
  const classes = useStyle();

  return (
    <div className={classes.LoadingStyle}>
      <div className={'eir-loading-container d-block text-left'}>
        <span className={'bg-secondary ' + classes.LoadingDots}></span>
        <span className={'bg-secondary ' + classes.LoadingDots}></span>
        <span className={'bg-secondary ' + classes.LoadingDots}></span>
        <span className={'bg-secondary ' + classes.LoadingDots}></span>
      </div>
      <Typography className={classes.LoadingText}>Checking availability</Typography>
    </div>
  )

}
